import { DynamicStyleSheet } from '@pulsar/core';

export default DynamicStyleSheet.create(theme => ({
  root: {
    color: theme.colors.linkDefault,
  },
}));
